import { useUserStore } from '@/store'
import type { Router } from 'vue-router'

// 使用路径的好处就是非vue框架下的能直接判断
export const whitePathList = ['/login', , '/file', '/not-found', '/task/screen-quiz', '/bridge']


export default function setupPermissionGuard(router: Router) {
  router.beforeEach(async(to, from, next) => {
    const userStore = useUserStore()
    const token = userStore.token

    // 如果要去登录页
    if (to.name === 'login') {
      // 如果已经登录了，跳转到首页
      if (token) {
        next({ name: 'home' })
      } else {
        // 未登录，正常进入登录页
        next()
      }
      return
    }
    // 白名单路由直接放行
    if (whitePathList.includes(to.path as string)) {
      next()
      return
    }

    // 其他路由，检查是否需要登录
    // 优先使用 meta.requiresAuth，如果没设置则默认需要登录
    const requiresAuth = to.meta.requiresAuth !== false

    if (requiresAuth && !token) {
      // 需要登录但未登录，跳转到登录页
      next({ name: 'login', query: { redirect: to.fullPath } })
    } else {
      // 不需要登录 或 已登录，放行
      next()
    }
  })
  router.afterEach(to => {
    if (to.meta.title) {
      document.title = to.meta.title as string
    } else {
      document.title = 'U课AI'
    }
  })
}
